import { streamText } from 'ai';

import { dixaGateway } from './provider';
import { type MimUIMessage } from './structuredResponse';

const TITLE_PROMPT = 'chat-title-generator';

const TITLE_MAX_LENGTH = 120;

const truncate = (text: string): string =>
  text.length > TITLE_MAX_LENGTH
    ? `${text.slice(0, TITLE_MAX_LENGTH - 1)}…`
    : text;

const toPromptText = (messages: MimUIMessage[]): string | undefined => {
  const prompt = messages.find((message) => message.role === 'user');
  const text = prompt?.parts
    .map((part) => (part.type === 'text' ? part.text : ''))
    .join('')
    .trim();

  return text ? text : undefined;
};

export const generateChatTitle = async (
  messages: MimUIMessage[],
): Promise<string | undefined> => {
  const prompt = toPromptText(messages);
  if (!prompt) return undefined;

  try {
    const result = streamText({
      model: dixaGateway(TITLE_PROMPT),
      prompt,
    });
    const text = await result.text;

    const title = text.trim().replace(/^["']|["']$/g, '');

    return truncate(title || prompt);
  } catch {
    return truncate(prompt);
  }
};
